module.exports = __webpack_public_path__ + "img/guara2.2a6ca6f3.png";